module.exports = __webpack_public_path__ + "static-v-shop/1770130202702/img/ic-beneficios.9a11f22a.png";